



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Member } from '../../models/member.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { Subject } from 'rxjs';
import { MemberDetailDialogComponent } from './member-detail-dialog/member-detail-dialog.component';
import { MemberAccess } from '../../models/member-access.model';
import { MemberAccessActionType } from '../../models/enums';

@Component({
    selector: 'members',
    template: require('./members.component.html'),
    styles: [require('./members.component.css')],
    animations: [fadeInOut]
})
export class MembersComponent {
    searchModel: any = {};
    isGettingMembers = false;
    memberDetailsParams: any = {};
    members: Member[] = [];
    currentUser: User;
    isSearching = false;
    perpage: number = 20;

    private subject: Subject<string> = new Subject();

    constructor(private router: Router, private apiService: ApiService, private authService: AuthService,
        public dialog: MatDialog, private alertService: AlertService) {
        this.currentUser = this.authService.currentUser;
        this.subject.debounceTime(1).subscribe(searchTextValue => {
            this.searchMembers();
        });
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

    //getMembers() {
    //    this.isGettingMembers = true;
    //    this.members = [];
    //    this.apiService.getMemberDetails(this.memberDetailsParams.startDate, this.memberDetailsParams.endDate).subscribe(r => {
    //        this.members = r;
    //        this.isGettingMembers = false;
    //    }, err => {
    //        this.isGettingMembers = false;
    //        this.alertService.showMessage(err.error, "", MessageSeverity.error);
    //    });
    //}

    onSearchMember(searchTextValue?: any, perpage?: number) {
        this.subject.next(searchTextValue);

        //var memberAccess = new MemberAccess();
        //memberAccess.startTime = new Date();
        //memberAccess.endTime = new Date();
        //memberAccess.memberAccessActionType = MemberAccessActionType.Search;
        //memberAccess.note = searchTextValue;
        //this.apiService.createMemberAccess(memberAccess).subscribe(r => {
        //});
    }

    searchMembers() {
        this.isGettingMembers = true;
        this.apiService.searchMembersByModel(this.searchModel, this.perpage).subscribe(r => {
            console.log(r)
            this.members = r;
            this.isGettingMembers = false;
        }, err => {
            this.isGettingMembers = false;
            this.alertService.showMessage(err.error, "", MessageSeverity.error);
        });
    }

    createEditMember(member: any) {
        //let dialogRef = this.dialog.open(CreateEditMemberModalComponent, {
        //    width: '600px',
        //    data: {
        //        currentMember: member || {},
        //        vendors: this.members
        //    }
        //});

        //dialogRef.afterClosed().subscribe(r => {
        //    this.getMembers();
        //})
    }

    deleteMember(memberId: number) {
        //this.alertService.showDialog("Do you want to delete this Member ?", DialogType.confirm, val => {

        //    this.apiService.deleteMember(memberId).subscribe(r => {
        //        this.getMembers();
        //    });
        //});
    }

    onActivate(event) {
        if (event.type === 'click') {
          
            //let dialogRef = this.dialog.open(MemberDetailDialogComponent, {
            //    panelClass: "col-md-9",
            //    data: {
            //        member: event.row
            //    }
            //});

            //dialogRef.afterClosed().subscribe(r => {
            //    //this.getMembers();
            //})
            var url = this.router.serializeUrl(
                this.router.createUrlTree(["/members/" + event.row.memberId])
            )
            window.open(url, '_blank')
            //this.router.navigateByUrl("/members/" + event.row.memberId)
        }
        
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/members/members.component.ts